import { AirConfigType } from '@core/layouts/types/user-profile.type'
import { Subject } from 'rxjs'

// theme.constants.ts
export const applyClientTheme = (
  themeData: AirConfigType,
  reloadTab: Subject<boolean>,
  isClientIdChanged: boolean = true,
) => {
  // buttons
  document.documentElement.style.setProperty('--buttonTextColor', themeData.buttonFontColor)
  document.documentElement.style.setProperty('--buttonHoverBg', themeData.buttonHovColor)
  document.documentElement.style.setProperty('--buttonBg', themeData.btnColorCode)
  document.documentElement.style.setProperty('--buttonActiveBgColor', themeData.buttonHovColor)
  document.documentElement.style.setProperty('--buttonActiveBorderColor', themeData.buttonHovColor)

  // tab
  document.documentElement.style.setProperty('--tabActiveDynamicBg', themeData.tabColor)
  document.documentElement.style.setProperty('--tabActiveStandardBg', themeData.btnColorCode)
  document.documentElement.style.setProperty('--tabActiveOutline', themeData.tabsOutlineColor)
  document.documentElement.style.setProperty('--standardTabOutline', themeData.tabColor)
  document.documentElement.style.setProperty('--tabFontColor', themeData.buttonFontColor)

  // banner
  document.documentElement.style.setProperty('--topBannerBg', themeData.bannerColorCode)

  // dropdown
  document.documentElement.style.setProperty('--dropDownMenuBg', themeData.menuColor)
  document.documentElement.style.setProperty('--dropDownMenuHover', themeData.menuHoverColor)
  document.documentElement.style.setProperty('--dropdownFontColor', themeData.buttonFontColor)

  // sideBar
  document.documentElement.style.setProperty('--sideBarFontColor', themeData.buttonFontColor)
  document.documentElement.style.setProperty('--sideBarMenuBgColor', themeData.menuColor)
  document.documentElement.style.setProperty('--sideBarMenuHoverColor', themeData.menuHoverColor)
  document.documentElement.style.setProperty('--sideBarActiveFontColor', themeData.buttonFontColor)
  document.documentElement.style.setProperty('--sideBarTabColor', themeData.tabColor)

  // sideBar Logo
  document.documentElement.style.setProperty('--sideBarLogoFontColor', themeData.buttonFontColor)
  document.documentElement.style.setProperty('--sideBarLogoBgColor', themeData.tabColor)
  document.documentElement.style.setProperty('--sideBarLogoActiveBgColor', themeData.tabColor)
  document.documentElement.style.setProperty('--sideBarLogoActiveFontColor', themeData.buttonFontColor)

  if (isClientIdChanged) reloadTab.next(true)
}

export const applyDefaultColourTheme = (themeData: AirConfigType, reloadTab: Subject<boolean>) => {
  // button
  document.documentElement.style.setProperty('--buttonTextColor', themeData.buttonFontColor)
  document.documentElement.style.setProperty('--buttonHoverBg', themeData.buttonHovColor)
  document.documentElement.style.setProperty('--buttonBg', themeData.btnColorCode)
  document.documentElement.style.setProperty('--buttonActiveBgColor', themeData.tabStandardOutlineColor)
  document.documentElement.style.setProperty('--buttonActiveBorderColor', themeData.tabStandardOutlineColor)

  // tab
  document.documentElement.style.setProperty('--tabActiveDynamicBg', themeData.tabDynamicBgColor)
  document.documentElement.style.setProperty('--tabActiveStandardBg', themeData.tabStandardBgColor)
  document.documentElement.style.setProperty('--tabActiveOutline', themeData.tabActiveOutline)
  document.documentElement.style.setProperty('--standardTabOutline', themeData.tabStandardOutlineColor)
  document.documentElement.style.setProperty('--tabFontColor', themeData.tabFontColor)

  // banner
  document.documentElement.style.setProperty('--topBannerBg', themeData.bannerColorCode)

  // dropdown
  document.documentElement.style.setProperty('--dropDownMenuBg', themeData.menuColor)
  document.documentElement.style.setProperty('--dropDownMenuHover', themeData.menuHoverColor)
  document.documentElement.style.setProperty('--dropdownFontColor', themeData.menuFontColor)

  // sideBar
  document.documentElement.style.setProperty('--sideBarFontColor', themeData.sideBarFontColor)
  document.documentElement.style.setProperty('--sideBarMenuBgColor', themeData.sideBarMenuBgColor)
  document.documentElement.style.setProperty('--sideBarMenuHoverColor', themeData.sideBarMenuHoverColor)
  document.documentElement.style.setProperty('--sideBarActiveFontColor', themeData.sideBarActiveFontColor)
  document.documentElement.style.setProperty('--sideBarTabColor', themeData.sideBarTabColor)

  // sideBar Logo
  document.documentElement.style.setProperty('--sideBarLogoFontColor', themeData.sideBarLogoFontColor)
  document.documentElement.style.setProperty('--sideBarLogoBgColor', themeData.sideBarLogoBgColor)
  document.documentElement.style.setProperty('--sideBarLogoActiveBgColor', themeData.sideBarLogoActiveBgColor)
  document.documentElement.style.setProperty('--sideBarLogoActiveFontColor', themeData.sideBarLogoActiveFontColor)
  reloadTab.next(true)
}
